export { PageFooterFormComponent as PageFooterDetail } from './component';


// WEBPACK FOOTER //
// ./src/pages/footer-form/index.tsx